var makeString = require('./helper/makeString');

module.exports = function include(str, needle) {
  if (needle === '') return true;
  return makeString(str).indexOf(needle) !== -1;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/underscore.string/include.js
 ** module id = 1081
 ** module chunks = 0
 **/